import React from 'react';
import {Card, CardContent, Stack, Typography, Grid2, Box} from "@mui/material";
import {CrimeReportList} from '../../crime-report-list/crime-report-list';
import {
    crimeScoreRiskDescription,
    getCrimeScoreRisk,
} from '../../../../../helpers/crimeScore';
import {SexOffendersInfo} from "../../sex-offenders-info/sex-offenders-info";
import {ReportTypes} from "../../../../../types";
import {LoadingButton} from "@mui/lab";
import {reportStyles} from "../../../../../components/reports/styles";
import { When } from 'react-if';
import {FieldSafetyReportResult} from "./field-safety-report-result";
import { Download } from '@mui/icons-material';

interface Props{
    address: string;
    crimeScore: number;
    sexOffenders: ReportTypes.SexOffender[];
    nearbyReports?: ReportTypes.NearbyReport[] | null;
    sexOffendersWithin3M: number | string;
    handleNext?: ()=>void;
    handleDelete?: ()=>void;
    handleDownload?: ()=>void;
    isPastReport?: boolean;
    reportType?: string;
    isDownloadIconVisible?: boolean;
    report?: ReportTypes.Model;
}

export const ReportResult: React.FC<Props> = ({
                                                  address,
                                                  crimeScore,
                                                  sexOffenders,
                                                  nearbyReports,
                                                  sexOffendersWithin3M,
                                                  handleNext,
                                                  isPastReport,
                                                  isDownloadIconVisible = true,
                                                  reportType,
                                                  report,
                                                  handleDelete,
                                                  handleDownload
                                              }) => {
    return (
        <Grid2>
            <Card className={'div-border-for-download'}>
                <CardContent sx={{padding:5}}>
                    <Stack>
                        <When condition={reportType === "Safety Report"}>
                            <Box sx={{textAlign:'center',marginBottom:3}}>
                                <Typography fontWeight={500} fontSize={20} lineHeight={"24px"}>
                                    {address}
                                </Typography>
                            </Box>
                            <CrimeReportList data={
                                sexOffenders?.length > 0
                                    ? [
                                        {
                                            crimeRisk:
                                                getCrimeScoreRisk(
                                                    crimeScore,
                                                    sexOffenders?.length
                                                )!,
                                            description:
                                                crimeScoreRiskDescription[
                                                    getCrimeScoreRisk(
                                                        crimeScore,
                                                        sexOffenders?.length
                                                    )!
                                                    ],
                                            crimeScore,
                                        },
                                    ]
                                    : []
                            }
                            />
                            <SexOffendersInfo passedInNearbyReports={nearbyReports} place={report?.place} crimeScore={crimeScore} address={address} sexOffenders={sexOffenders} sexOffendersWithin3M={sexOffendersWithin3M}/>
                        </When>
                        <When condition={report && reportType !== "Safety Report"}>
                            <FieldSafetyReportResult report={report!}/>
                        </When>
                        <When condition={isDownloadIconVisible}>
                            <Box sx={{margin:'auto',display:'flex',flexDirection:'row',gap:2}}>
                                <When condition={!isPastReport && !!handleDownload}>
                                    <LoadingButton
                                        sx={{
                                            marginTop:6,
                                            marginBottom:2,
                                            ...reportStyles.button
                                        }}
                                        variant="outlined"
                                        loading={false}
                                        onClick={handleDownload}
                                        disabled={false}
                                        startIcon={<Download />}
                                    >
                                        <Typography fontWeight={500} fontSize={14} lineHeight={"24px"}>
                                            Download PDF
                                        </Typography>
                                    </LoadingButton>
                                </When>
                                <LoadingButton
                                    sx={{
                                        marginTop:6,
                                        marginBottom:2,
                                        ...reportStyles.button
                                    }}
                                    variant="contained"
                                    loading={false}
                                    onClick={handleNext}
                                    disabled={false}
                                >
                                    <Typography fontWeight={500} fontSize={14} lineHeight={"24px"}>
                                        {isPastReport? "Download" : "Next"}
                                    </Typography>
                                </LoadingButton>
                                <When condition={report && reportType !== "Safety Report"}>
                                    <LoadingButton
                                        sx={{
                                            marginTop:6,
                                            marginBottom:2,
                                            marginLeft:1,
                                            ...reportStyles.button
                                        }}
                                        variant="contained"
                                        color={"error"}
                                        loading={false}
                                        onClick={handleDelete}
                                        disabled={false}
                                    >
                                        <Typography fontWeight={500} fontSize={14} lineHeight={"24px"}>
                                            Delete
                                        </Typography>
                                    </LoadingButton>
                                </When>
                            </Box>
                        </When>
                    </Stack>
                </CardContent>
            </Card>
        </Grid2>
    )
}